const emptyObject = {}

Object.freeze(emptyObject)

export default emptyObject



// WEBPACK FOOTER //
// ./src/empty.js